import {
  IJobListFilters,
  IJobSearchType,
  JobQuickFilters,
  NewApplicantsCounterResults,
} from '@th-types/jobs.type';
import { jobFilterMap } from '@utils/JobUtils';
import { Badge, Stack } from 'react-bootstrap';

interface Props {
  jobListFilters: IJobListFilters;
  countHiddenJobs: number;
  executeJobsViewBadgeAction: (quickFilter: JobQuickFilters) => void;
  newApplicantsCounters?: NewApplicantsCounterResults;
}

export default function JobViewQuickFilters({
  jobListFilters,
  countHiddenJobs,
  executeJobsViewBadgeAction,
  newApplicantsCounters,
}: Props) {
  const getJobsFilterBadgeText = (quickFilterName: JobQuickFilters) => {
    switch (quickFilterName) {
      case JobQuickFilters.HIDDEN_JOBS:
        return `${quickFilterName} (${countHiddenJobs})`;
      case JobQuickFilters.NEW_APPLICANTS:
        return `${quickFilterName} (${newApplicantsCounters?.totalJobsWithNewApplicants || 0})`;
      default:
        return quickFilterName;
    }
  };

  const getJobsViewBadgeTextColor = (quickFilterName: JobQuickFilters) => {
    const filterKey = jobFilterMap[quickFilterName];
    return jobListFilters[filterKey] ? 'secondary' : 'light';
  };

  const isBadgeDisabled = (quickFilterName: JobQuickFilters) => {
    switch (quickFilterName) {
      case JobQuickFilters.HIDDEN_JOBS:
        return countHiddenJobs === 0 && !jobListFilters.hiddenJobs;
      case JobQuickFilters.NEW_APPLICANTS:
        return (
          newApplicantsCounters?.totalJobsWithNewApplicants === 0 &&
          !jobListFilters.newApplicantsOnly
        );
      default:
        return false;
    }
  };

  return (
    <Stack direction="horizontal">
      {Object.values(JobQuickFilters).map((quickFilterName) => {
        return (
          <Badge
            className={`me-2 badge-header${isBadgeDisabled(quickFilterName) ? ' badge-disabled' : ''}`}
            pill
            bg={getJobsViewBadgeTextColor(quickFilterName)}
            hidden={
              quickFilterName === JobQuickFilters.NEW_APPLICANTS &&
              jobListFilters.jobSearchType !== IJobSearchType.ACTIVE_MEMBER
            }
            text="dark"
            key={quickFilterName}
            onClick={() => {
              if (!isBadgeDisabled(quickFilterName)) {
                executeJobsViewBadgeAction(quickFilterName);
              }
            }}
          >
            {getJobsFilterBadgeText(quickFilterName)}
          </Badge>
        );
      })}
    </Stack>
  );
}
